<div class="hierarchical-filters">
	<div class="scope-select-wrapper">
		<label class="scope-select-label">Machine type</label>
		<kt-searchable-select
			placeholder="Machine type"
			[options]="machineTypeOptions"
			[multiple]="false"
			[searchable]="false"
			[(ngModel)]="machineType">
		</kt-searchable-select>
	</div>
	<div class="scope-select-wrapper">
		<label class="scope-select-label">Status</label>
		<kt-searchable-select
			placeholder="Status"
			[options]="statusOptions"
			[multiple]="false"
			[searchable]="false"
			[(ngModel)]="selStatus">
		</kt-searchable-select>
	</div>
</div>
<div class="row mt-5">
	<button mat-raised-button class="mr-auto ml-3" color="warn" (click)="back()">Back</button>
	<button mat-raised-button class="ml-auto mr-3" color="primary" (click)="submit()">Submit</button>
</div>


